import { useMemo } from 'react';
import chroma from 'chroma-js';

import useWorkingProjectColorsByV2Names from '../use-working-project-colors-by-v2-names';
import getRelativeContrastColor from './generate-relative-contrasting-color';

const useCreateThemeColorCssVariables = () => {
  const projectThemeColors = useWorkingProjectColorsByV2Names();

  // precomputing color variables and contrast colors once here so we don't
  // have to do it every time we render an instance of a project color component.
  // Also, this let's use it in css files if we need to.
  return useMemo(() => {
    const contrastList: string[] = [];

    const colorVariablesList = Object.entries(projectThemeColors).map(([variableName, colorArray]) => {
      if (!chroma.valid(colorArray[0])) return '';

      const topColor = chroma(colorArray[0])
        .alpha(colorArray[1] ?? 1)
        .hex();

      Object.entries(projectThemeColors).forEach(([subVariableName, subColorArray]) => {
        if (chroma.valid(subColorArray[0])) {
          const subColor = chroma(subColorArray[0])
            .alpha(subColorArray[1] ?? 1)
            .hex();
          const contrastColor = getRelativeContrastColor(subColor, topColor);
          contrastList.push(
            `--project-theme-color-contrast-${subVariableName}-over-${variableName}: ${contrastColor};`
          );
        }
      });
      return `--project-theme-color-${variableName}: ${topColor};`;
    });

    return { colorVariablesList: colorVariablesList.join('\n'), contrastColorsList: contrastList.join('\n') };
  }, [projectThemeColors]);
};

export default useCreateThemeColorCssVariables;
